import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const AnnouncementBar = () => {
  return (
    <div className="bg-stone-900 text-white py-2.5 px-4 relative z-[110] overflow-hidden">
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-4 text-[10px] sm:text-xs font-bold uppercase tracking-[0.2em]">
        <motion.div 
          animate={{ scale: [1, 1.1, 1] }}
          transition={{ duration: 2, repeat: Infinity }}
          className="flex items-center gap-2 text-amber-400"
        >
          <SafeIcon name="Gift" className="w-4 h-4" />
          <span>Benefício Exclusivo</span>
        </motion.div>
        
        <span className="hidden sm:inline opacity-30">|</span>
        
        <p className="text-stone-300">
          Garanta <span className="text-white">15% OFF</span> no primeiro agendamento de 2026
        </p>

        <button 
          onClick={() => document.getElementById('cadastro')?.scrollIntoView({ behavior: 'smooth' })}
          className="hidden md:flex items-center gap-1 text-amber-400 hover:text-amber-300 transition-colors border-b border-amber-400/30"
        >
          Cadastre-se <SafeIcon name="ArrowRight" className="w-3 h-3" />
        </button>
      </div>
      
      {/* Luz sutil passando pela barra */}
      <motion.div 
        animate={{ x: ['-100%', '200%'] }}
        transition={{ duration: 5, repeat: Infinity, ease: "linear" }}
        className="absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent pointer-events-none"
      />
    </div>
  );
};

export default AnnouncementBar;